function initOfferGallery(sectionId) {
  var mainEl = document.getElementById('offer-main-' + sectionId);
  if (!mainEl || typeof Swiper === 'undefined') return;

  if (mainEl._swiperInstance) {
    mainEl._swiperInstance.destroy(true, true);
    delete mainEl._swiperInstance;
  }

  var mainSwiper = new Swiper(mainEl, { spaceBetween: 0 });
  mainEl._swiperInstance = mainSwiper;

  var thumbsEl = document.getElementById('offer-thumbs-' + sectionId);
  if (!thumbsEl) return;

  if (thumbsEl._swiperInstance) {
    thumbsEl._swiperInstance.destroy(true, true);
    delete thumbsEl._swiperInstance;
  }

  var thumbsSwiper = new Swiper(thumbsEl, {
    slidesPerView: 4,
    spaceBetween: 8,
    freeMode: true
  });
  thumbsEl._swiperInstance = thumbsSwiper;

  var thumbSlides = Array.from(thumbsEl.querySelectorAll('.offer__gallery-thumb'));

  function setActive(index) {
    thumbSlides.forEach(function (t) { t.classList.remove('is-active'); });
    if (thumbSlides[index]) thumbSlides[index].classList.add('is-active');
  }

  setActive(0);

  thumbSlides.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      mainSwiper.slideTo(i);
      setActive(i);
    });
  });

  mainSwiper.on('slideChange', function () {
    setActive(mainSwiper.activeIndex);
  });

  initOfferLightbox(mainEl.closest('[data-offer-gallery]'), mainSwiper);
}

function initOfferLightbox(galleryEl, mainSwiper) {
  var zoomButtons = Array.from(galleryEl.querySelectorAll('.offer__gallery-zoom'));
  var lightbox = galleryEl.querySelector('[data-offer-lightbox]');
  if (!zoomButtons.length || !lightbox || lightbox._lightboxBound) return;
  lightbox._lightboxBound = true;

  var imgEl = lightbox.querySelector('[data-offer-lightbox-img]');
  var closeEls = lightbox.querySelectorAll('[data-offer-lightbox-close]');
  var prevBtn = lightbox.querySelector('[data-offer-lightbox-prev]');
  var nextBtn = lightbox.querySelector('[data-offer-lightbox-next]');
  var sources = zoomButtons.map(function (btn) { return btn.dataset.fullSrc; });
  var currentIndex = 0;

  function render() {
    imgEl.src = sources[currentIndex];
  }

  function open(index) {
    currentIndex = index;
    render();
    lightbox.hidden = false;
    document.body.classList.add('offer-lightbox-open');
  }

  function close() {
    lightbox.hidden = true;
    imgEl.src = '';
    document.body.classList.remove('offer-lightbox-open');
  }

  function show(index) {
    currentIndex = (index + sources.length) % sources.length;
    render();
    if (mainSwiper) mainSwiper.slideTo(currentIndex);
  }

  zoomButtons.forEach(function (btn, i) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      open(i);
    });
  });

  closeEls.forEach(function (el) { el.addEventListener('click', close); });
  if (prevBtn) prevBtn.addEventListener('click', function () { show(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { show(currentIndex + 1); });

  document.addEventListener('keydown', function (e) {
    if (lightbox.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') show(currentIndex - 1);
    if (e.key === 'ArrowRight') show(currentIndex + 1);
  });
}

function initAll() {
  if (typeof Swiper === 'undefined') {
    setTimeout(initAll, 50);
    return;
  }
  document.querySelectorAll('[data-offer-gallery]').forEach(function (el) {
    initOfferGallery(el.dataset.offerGallery);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

document.addEventListener('shopify:section:load', function (e) {
  var gallery = e.target.querySelector('[data-offer-gallery]');
  if (gallery) initOfferGallery(gallery.dataset.offerGallery);
});
